export type DetalheProdutoCupom = {
    descricao: string;
    valor: any;
    observacao: boolean;
};

export type ProdutoCupomNormalizado = {
    descricaoPrincipal: string;
    valorPrincipal: any;
    detalhes: DetalheProdutoCupom[];
};

export function deveExibirCategoriaNoCupom(configuracao: any, pedido?: any): boolean {
    // Pedidos importados armazenam o nome do produto em categoria e o preço-base em valor.
    return pedido?.pedidoIfood === true
        || pedido?.pedido99Food === true
        || configuracao?.exibirCategoriaNoCupom !== false;
}

export function normalizarProdutoCupom(
    produto: any,
    exibirCategoria: boolean = true
): ProdutoCupomNormalizado {
    const descricoes = Array.isArray(produto?.descricao) ? produto.descricao : null;

    if (!descricoes) {
        return {
            descricaoPrincipal: String(produto?.descricao || produto?.nome || 'Item'),
            valorPrincipal: produto?.valor,
            detalhes: []
        };
    }

    const detalhesNormalizados = descricoes.map((item: any) => ({
        descricao: String(item?.descricao || '').trim(),
        valor: item?.valor,
        observacao: item?.categoria === 'Observação'
    }));
    const detalhes = detalhesNormalizados.filter((item: DetalheProdutoCupom) => item.descricao);

    if (produto?.tipo === 'pizzas') {
        const quantidadeSabores = Number(produto?.quantidadeSabores) || 0;
        // Pizzas mantêm o layout original de tamanho e sabores, independentemente do toggle.
        return {
            descricaoPrincipal: `${produto?.tamanho || ''} ${quantidadeSabores} ${quantidadeSabores === 1 ? 'SABOR' : 'SABORES'}`.trim(),
            valorPrincipal: produto?.valor,
            detalhes
        };
    }

    if (exibirCategoria) {
        return {
            descricaoPrincipal: String(produto?.categoria || 'Item'),
            valorPrincipal: produto?.valor,
            detalhes
        };
    }

    const [primeiroDetalhe, ...demaisDetalhes] = detalhesNormalizados;
    if (!primeiroDetalhe?.descricao) {
        return {
            descricaoPrincipal: 'Item',
            valorPrincipal: produto?.valor,
            detalhes: demaisDetalhes.filter((item: DetalheProdutoCupom) => item.descricao)
        };
    }

    return {
        descricaoPrincipal: primeiroDetalhe.descricao,
        valorPrincipal: primeiroDetalhe.valor,
        detalhes: demaisDetalhes.filter((item: DetalheProdutoCupom) => item.descricao)
    };
}

function formatarValorCupom(valor: any): string {
    const numero = typeof valor === 'number'
        ? valor
        : Number(String(valor ?? 0).replace(/\./g, '').replace(',', '.'));
    return (Number.isFinite(numero) ? numero : 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

export function montarLinhasProdutoCupomHtml(
    produto: any,
    exibirCategoria: boolean,
    quebrarTextoEmLinhas: (texto: string, tamanhoMaximo: number) => string[],
    largura: number
): string {
    const itemCupom = normalizarProdutoCupom(produto, exibirCategoria);
    const linhasPrincipais = quebrarTextoEmLinhas(
        `${itemCupom.descricaoPrincipal} (R$ ${formatarValorCupom(itemCupom.valorPrincipal)})`,
        largura
    );

    const principalHtml = linhasPrincipais.map((linha, indexLinha) => `
        <tr>
            ${indexLinha === 0 ? `
                <td colspan="2" class="regular-itens">${formatarValorCupom(produto?.quantidade)} | ${linha}</td>
            ` : `
                <td>&nbsp;</td>
                <td class="regular-itens">${linha}</td>
            `}
        </tr>
    `).join('');

    const detalhesHtml = itemCupom.detalhes.map((detalhe) =>
        quebrarTextoEmLinhas(
            detalhe.observacao
                ? `Observação: ${detalhe.descricao}`
                : `- ${detalhe.descricao} (R$ ${formatarValorCupom(detalhe.valor)})`,
            largura
        ).map((linha) => `
            <tr>
                <td>&nbsp;</td>
                <td class="regular-itens${detalhe.observacao ? ' sublinhado-on' : ''}">${linha}</td>
            </tr>
        `).join('')
    ).join('');

    return principalHtml + detalhesHtml;
}
